import { Ear } from "lucide-react";
import { Switch } from "../ui/switch";

/**
 * Hands-free toggle card: shows status pill + audio meter when active.
 */
export default function HandsFreeToggle({
  handsFree,
  hfStatus,
  hfLevel,
  onToggle,
  disabled,
}) {
  return (
    <div
      className="border border-zinc-200 rounded-xl bg-white p-4 flex items-center justify-between gap-4 flex-wrap"
      data-testid="hands-free-card"
    >
      <div className="flex items-start gap-3 max-w-xl">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors ${
          handsFree ? "bg-zinc-900 text-white" : "bg-zinc-100 text-zinc-700"
        }`}>
          <Ear className="w-5 h-5" />
        </div>
        <div>
          <p className="font-heading text-lg tracking-tight text-zinc-900">Hands-free mode</p>
          <p className="text-sm text-zinc-600 mt-0.5">
            Keep the mic open. The app detects who's speaking by language and translates automatically.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        {handsFree && (
          <div className="flex items-center gap-3" data-testid="hands-free-status">
            <span className={`inline-flex items-center gap-2 text-sm font-medium ${
              hfStatus === "speaking" ? "text-red-600"
              : hfStatus === "processing" ? "text-amber-600"
              : "text-emerald-700"
            }`}>
              <span className={`w-2 h-2 rounded-full ${
                hfStatus === "speaking" ? "bg-red-600 animate-pulse"
                : hfStatus === "processing" ? "bg-amber-500 animate-pulse"
                : "bg-emerald-500 animate-pulse"
              }`} />
              {hfStatus === "speaking"
                ? "Hearing speech"
                : hfStatus === "processing"
                ? "Translating"
                : "Listening"}
            </span>
            <div className="w-24 h-2 rounded-full bg-zinc-100 overflow-hidden" data-testid="hands-free-meter">
              <div
                className="h-full bg-zinc-900 transition-[width] duration-75"
                style={{ width: `${Math.round(hfLevel * 100)}%` }}
              />
            </div>
          </div>
        )}
        <Switch
          checked={handsFree}
          onCheckedChange={onToggle}
          disabled={disabled}
          data-testid="hands-free-toggle"
        />
      </div>
    </div>
  );
}
